<template >
  <div>
    <div class="app-modal__box" :class="mode ? '' : 'performance__night'">
      <div class="app-modal__in">
        <div class="app-modal__header d-flex f-between p-5 m-title-modal">
          <p class="large--title m-0" :class="mode ? 'text__day2' : 'text__night2'">Новый Gust</p>
          <div>
            <crm-store-update-close
              :permission="$options.name"
              :button_type="'store'"
              :loading="loadingButton"
              @c-submit="submit(true)"
              @c-close="close()"
            ></crm-store-update-close>
          </div>
        </div>
      </div>
      <!-- app-modal__header end -->
      <div class="app-modal__body p-5 pb-0">
        <div class="timeline-items__right rounded-sm w-100 p-4" :class="mode ? 'table__myday' : 'table__mynight'">
          <el-form ref="form" status-icon :model="form" :rules="rules">
            <el-row :gutter="20">
              <el-col :span="12">
                <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                  {{ $t("message.car_number") }}
                </span>
                <el-form-item prop="full_name" size="medium">
                    
                    <crm-input
                      :inputValue="form.full_name"
                      v-model="form.full_name"
                      :placeholder="$t('message.full_name')"
                      :class="mode ? 'input__day' : 'input__night'"
                    ></crm-input>
                 </el-form-item>
              </el-col>
              <!-- end col -->
              <el-col :span="12">
                <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                  {{ $t("message.gender") }}
                </span>
                <el-form-item prop="gender_id" class="label_mini">
                  <select-gender
                    :id="form.gender_id"
                    v-model="form.gender_id"
                  ></select-gender>
                </el-form-item>
                
              </el-col>
             
              <!-- end col -->
              <el-col :span="12">
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.additional_information") }}
                  </span>
                  <el-form-item prop="additional_information" class="label_mini">
                   <el-input
                        type="textarea"
                        :placeholder="$t('message.additional_information')"
                        v-model="form.additional_information"
                        :class="mode ? 'input__day' : 'input__night'"
                      >
                      </el-input>
                  </el-form-item>
                </div>
              </el-col>
             
            
              <el-col :span="12">
                  <select-company
                    :id="form.visit_company_id"
                    v-model="form.visit_company_id"
                  ></select-company>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <!-- end app-modal__body -->
    </div>
   
    
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import drawer from "@/utils/mixins/drawer";
import form from "@/utils/mixins/form";
import selectCompany from "@/components/filters/inventory/select-or-hidden-company";
import selectGuestCarModel from "@/components/filters/inventory/select-guest-car-model";
import selectStaff from "@/components/filters/inventory/select-staff";
import selectGender from "@/components/filters/inventory/select-gender";


export default {
  mixins: [form, drawer],
  components: { selectGender, selectCompany },
  data() {
    return {
       dialogCreateModel: false,
      loadingButton: false,

    };
  },
  created() {},
  computed: {
    ...mapGetters({
      rules: "guest/rules",
      model: "guest/model",
      columns: "guest/columns",
      mode: "MODE"
    }),
  },
  methods: {
    ...mapActions({
      save: "guest/store",
      empty: "guest/empty",
      guestInventory: "guest/inventory",
      updateList:"guest/index"
    }),
     submit() {
      this.$refs["form"].validate((valid) => {
        if (valid && !this.loadingButton) {
          this.loadingButton = true;
          this.save(this.form)
            .then((res) => {
              this.$alert(res);
              if (res.status == 201) {
                this.$parent.$parent.form.guest_id=res.data.result.data.guest_id;                  
                this.form = JSON.parse(
                  JSON.stringify({
                    full_name: "",
                    gender_id: null,
                    additional_information: "",
                  })
                );
                this.parent().listChanged();
                this.guestInventory();
                this.updateList();
                this.close();
                
                this.$parent.$parent.dialogCreateGuest = false;               
              }
              this.loadingButton = false;
            })
            .catch((err) => {
              this.loadingButton = false;
              this.$alert(err);
            });
        }
      });
    },
  },
};
</script>

